export default (state = [], action) => {
    switch (action.type) {
        case "SEARCH_RESULTS_PAGE_DATA":
            return action.payload;
        default:
            return state;
    }
};